import {DateTime} from 'luxon';

export const DATE_FORMAT = 'y-MM-dd';

export const parseDateToLuxon = (value: string) => DateTime.fromFormat(value, DATE_FORMAT);

